<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ equipment }}</h5>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <!-- <b-form-text id="groupNameInputHelp">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              maxlength="24"
              size="sm"
              :formatter="notEmpty"
              aria-describedby="nameInput nameInputLiveFeedback"
              id="nameInput"
              :state="nameState && notRepeatedName"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text >Modelo *</b-form-text>
            <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
            <b-form-select
              v-model="form.FK_MODEL"
              :options="actuatorsModels"
              text-field="NAME"
              value-field="ID"
              size="sm"
              aria-describedby="modelSelectLiveFeedback"
              :state="modelState"
            >
              <template slot="first">
                <option :value="null" disabled>Selecione o modelo *</option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback
              v-if="!modelState"
              id="modelSelectLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
          <div class="group-inputs-title">Localização:</div>
          <b-form-text >Latitude </b-form-text>
            <!-- <b-form-text v-show="form.LATITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LATITUDE"
              placeholder="0"
              aria-describedby="latInputLiveFeedback"
              :state="LATstate"
              maxlength="40"
              size="sm"
            >
              <!-- :formatter='notEmpty' -->
            </b-form-input>
            <b-form-invalid-feedback v-if="!LATstate" id="latInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Latitudes não podem ter valor menor que
              -90 ou maior que 90 graus.
            </b-form-invalid-feedback>
            <b-form-text >Longitude</b-form-text>
            <!-- <b-form-text v-show="form.LONGITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LONGITUDE"
              placeholder="0"
              size="sm"
              aria-describedby="lonInputLiveFeedback"
              :state="LONstate"
              maxlength="40"
            >
              <!-- :formatter='notEmpty' -->
            </b-form-input>
            <b-form-invalid-feedback v-if="!LONstate" id="lonInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Longitudes não podem ter valor menor que
              -180 ou maior que 180 graus.
            </b-form-invalid-feedback>
          </div>
          <!-- <h5>Parâmetros</h5> -->

          <div class="col-xs-12 pl-3 pr-3">
            <div class="group-inputs-title">Parâmetros:</div>

            <!-- <b-form-text v-if='!form.TYPE' id='closureTimeInputLiveHelp'>
              Tempo de fechamento (s)
            </b-form-text>
            <b-form-input v-if='!form.TYPE'
                          v-model='form.CLOSURE_TIME'
                          type='number'
                          min='1'
                          aria-describedby='closureTimeInputLiveHelp'
                          state='valid'>
            </b-form-input>
            <b-form-input v-if='form.TYPE'
                          v-model='form.MAX_FLOW' -->
            <b-form-text
              >Vazão máxima (m³/h)</b-form-text
            >
            <!-- <b-form-text v-show="form.MAX_FLOW"
              >Vazão máxima (m³/h)</b-form-text
            > -->
            <b-form-input
              v-model="form.MAX_FLOW"
              placeholder="0"
              :state="maxFlowState"
              size="sm"
            ></b-form-input>
            <!-- :formatter='notEmpty' -->
            <!-- <b-form-input v-if='form.TYPE'
                          v-model='form.MIN_FLOW' -->
            <b-form-text
              >Vazão mínima (m³/h)</b-form-text
            >
            <!-- <b-form-text v-show="form.MIN_FLOW"
              >Vazão mínima (m³/h)</b-form-text
            > -->
            <b-form-input
              v-model="form.MIN_FLOW"
              placeholder="0"
              :state="minFlowState"
              size="sm"
            ></b-form-input>
            <!-- :formatter='notEmpty' -->
            <!-- <b-form-input v-if='form.TYPE'
                          v-model='form.REQ_PRES' -->
            <b-form-text
              >Pressão requerida (bar)</b-form-text
            >
            <!-- <b-form-text v-show="form.REQ_PRES"
              >Pressão requerida (bar)</b-form-text
            > -->
            <b-form-input
              v-model="form.REQ_PRES"
              placeholder="0"
              :state="reqPresState"
              size="sm"
            ></b-form-input>
            <!-- :formatter='notEmpty' -->
          </div>
          <div class="col-xs-12 pl-3 pr-3">
          <div class="group-inputs-title">Equipamentos associados</div>
            <b-form-text >Hidrômetro</b-form-text>
            <!-- <b-form-text v-show="form.FK_HYDRO">Hidrômetro</b-form-text> -->
            <b-form-select
              v-model="form.FK_HYDRO"
              :options="hydros"
              text-field="NAME"
              value-field="ID"
              state="valid"
              size="sm"
            >
              <template slot="first">
                <option :value="null">Hidrômetro</option>
              </template>
            </b-form-select>
            <!-- <b-form-select v-model='form.FK_MASTER' -->
            <b-form-text >Bomba</b-form-text>
            <!-- <b-form-text v-show="form.FK_PUMP">Bomba</b-form-text> -->
            <b-form-select
              v-model="form.FK_PUMP"
              :options="pumps"
              text-field="NAME"
              value-field="ID"
              state="valid"
              size="sm"
            >
              <template slot="first">
                <option :value="null">Bomba</option>
              </template>
            </b-form-select>
            <b-form-text >Sensor</b-form-text>
            <!-- <b-form-text v-show="form.FK_SENSOR">Sensor</b-form-text> -->
            <b-form-select
              v-model="form.FK_SENSOR"
              :options="sensors"
              text-field="NAME"
              size="sm"
              value-field="ID"
              state="valid"
            >
              <template slot="first">
                <option :value="null">Sensor</option>
              </template>
            </b-form-select>
            <b-form-text v-show="form.FK_SENSOR && form.POS_SENSOR"
              >Medição do Sensor</b-form-text
            >
            <b-form-select
              v-if="form.FK_SENSOR"
              v-model="form.POS_SENSOR"
              size="sm"
              :state="sensorMeasureToActuatorState"
            >
              <template slot="first">
                <option :value="null">Medição do sensor</option>
              </template>
              <!-- olhar aqui -->
              <option
                v-for="(measure, index) in auxSensors.filter(
                  (e) => e.ID == form.FK_SENSOR
                )"
                :key="index"
                :value="measure.POS"
              >
                {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
              </option>
            </b-form-select>
            <!-- REMOVER A AÇÃO DIRETA E INVERSA NO CADASTRO DE DIR -->
            <!-- <b-form-radio-group
              v-if="form.FK_SENSOR && form.POS_SENSOR !== null"
              v-model="form.ACTION_SENSOR"
            >
              <b-form-radio :value="0">Ação Inversa</b-form-radio>
              <b-form-radio :value="1">Ação Direta</b-form-radio>
            </b-form-radio-group> -->

          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <div class="group-inputs-title">
              Extra:
            </div>
            <b-form-text>Observações</b-form-text>
            <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
            <b-form-input
              v-model="form.NOTE"
              placeholder="Observações"
              state="valid"
              maxlength="40"
              size="sm"
            >
            </b-form-input>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="ml-2 mr-1"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  testName,
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
export default {
  name: "actuator-form",
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    actuatorsModels: Array,
    hydros: Array,
    pumps: Array,
    sensors: Array,
    auxSensors: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        // TYPE: 0,
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        // CLOSUTE_TIME: null,
        MAX_FLOW: null,
        MIN_FLOW: null,
        REQ_PRES: null,
        FK_HYDRO: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        FK_PUMP: null,
        // FK_MASTER: null,
        NOTE: null,
      },
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.FK_HYDRO = this.itemToEdit.FK_HYDRO;
          this.form.FK_SENSOR = this.itemToEdit.FK_SENSOR;
          this.form.POS_SENSOR = this.itemToEdit.POS_SENSOR;
          this.form.ACTION_SENSOR = this.itemToEdit.ACTION_SENSOR;
          this.form.FK_PUMP = this.itemToEdit.FK_PUMP;
          // this.form.FK_MASTER = this.itemToEdit.FK_MASTER;
          // this.form.CLOSURE_TIME = this.itemToEdit.CLOSURE_TIME;
          this.form.MAX_FLOW = this.itemToEdit.MAX_FLOW;
          this.form.MIN_FLOW = this.itemToEdit.MIN_FLOW;
          this.form.REQ_PRES = this.itemToEdit.REQ_PRES;
          this.form.NOTE = this.itemToEdit.NOTE;
          // this.form.TYPE = this.itemToEdit.TYPE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    modelState() {
      return !!this.form.FK_MODEL;
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    maxFlowState() {
      let maxFlow = String(Number(this.form.MAX_FLOW));
      if (maxFlow == "NaN" || maxFlow < 0) return false;
      return true;
    },
    minFlowState() {
      let minFlow = String(Number(this.form.MIN_FLOW));
      if (minFlow == "NaN" || minFlow < 0) return false;
      return true;
    },
    reqPresState() {
      let reqPres = String(Number(this.form.REQ_PRES));
      if (reqPres == "NaN" || reqPres < 0) return false;
      return true;
    },
    sensorMeasureToActuatorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR === null) return false;
      return true;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        // TYPE: 0,
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        // CLOSUTE_TIME: null,
        MAX_FLOW: null,
        MIN_FLOW: null,
        REQ_PRES: null,
        FK_HYDRO: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        // ACTION_SENSOR: null,
        FK_PUMP: null,
        // FK_MASTER: null,
        NOTE: null,
      };
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.modelState,
        this.LATstate,
        this.LONstate,
        this.sensorMeasureToActuatorState,
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "O equipmamento precisa ter um modelo.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
        "Verifique a configuração do sensor atribuído ao atuador.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      this.form.LATITUDE = !!this.form.LATITUDE
        ? parseFloat(this.form.LATITUDE)
        : null;
      this.form.LONGITUDE = !!this.form.LONGITUDE
        ? parseFloat(this.form.LONGITUDE)
        : null;
      this.form.MAX_FLOW = !!this.form.MAX_FLOW
        ? parseFloat(this.form.MAX_FLOW)
        : null;
      this.form.MIN_FLOW = !!this.form.MIN_FLOW
        ? parseFloat(this.form.MIN_FLOW)
        : null;
      this.form.REQ_PRES = !!this.form.REQ_PRES
        ? parseFloat(this.form.REQ_PRES)
        : null;
      if (this.form.POS_SENSOR == null) this.form.ACTION_SENSOR = null;
      else if (this.form.ACTION_SENSOR == null) this.form.ACTION_SENSOR = 0;
      // this.form.CLOSURE_TIME = this.form.CLOSURE_TIME > 0 || this.form.CLOSURE_TIME == null ? this.form.CLOSURE_TIME : null;
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
